import React,{ useEffect, useState } from "react";

import { useParams, useNavigate } from "react-router-dom";
import { MapPin, ArrowLeft } from "lucide-react";
import "./ProjectDetails.css"; 
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import { projects ,ICONS} from "./projects";

import EnquiryModal from "../components/EnquiryModal/EnquiryModal";



const ProjectDetails = () => {
  const [openEnquiry, setOpenEnquiry] = useState(false);
  const [brochureUnlocked, setBrochureUnlocked] = useState(false);

  const { slug } = useParams();
  const navigate = useNavigate();

  const project = projects?.find((p) => p.slug === slug);
    const [currentIndex, setCurrentIndex] = React.useState(0);

    useEffect(() => {
  window.scrollTo(0, 0);
}, [slug]);

 useEffect(() => {
    if (!project?.img || project.img.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % project.img.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [project]);

  if (!project) {
    return (
      <>
        <Navbar />
        <h2 style={{ padding: 40 }}>Project not found</h2>
        <Footer />
      </>
    );
  }



  return (
    <>
      {/* ✅ NAVBAR */}
      <Navbar />

      {/* ✅ PROJECT CONTENT */}
      <section className="project-details">
        <button className="back-btn1" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} /> Back
        </button>

        <div className="details-grid">
          <img src={project.image} alt={project.title} />

          <div className="details-info">
            <h1>{project.title}</h1>

            <p className="location">
              <MapPin size={14} /> {project.location}
            </p>

            <span className={`status ${project.statusType}`}>
              {project.status}
            </span>

            {/* <p className="Project">{project.projects}</p> */}

            <p className="desc">{project.topTag}</p>

            <div className="project-description">
 <p className="intro">
    <strong>{project.title}</strong>, {project.description.intro}
  </p>

  <h3>✨ Project Highlights</h3>
  <ul>
    {project.description.highlights.map((item, i) => (
      <li key={i}>{item}</li>
    ))}
  </ul>

  <h3>🏡 Unit Configurations</h3>
  <ul>
    {project.description.configurations.map((item, i) => (
      <li key={i}>{item}</li>
    ))}
  </ul>

  <h3>Starting Price</h3>
  <ul>
    <li>
      <span style={{ fontSize: "20px" }}>
        {project.description.price}
      </span>
    </li>
  </ul>

<div className="brochure-actions">
  <button
    className="download-brochure-btn"
    onClick={() => {
         setOpenEnquiry(true);
      // if (brochureUnlocked) {
      //   // ✅ direct download (no modal)
      //   const link = document.createElement("a");
      //   link.href = project.Brochure;
      //   link.download = "Jayaram-Infracon-Brochure.pdf";
      //   link.click();
      // } else {
      //   // ❌ open enquiry modal first time
      //   setOpenEnquiry(true);
      // }
    }}
  >
    Download Brochure
  </button>
</div>


</div>

          </div>
        </div>

        <br/>
          <br/>
            <br/>


        {/* {project?.img && project?.img.length > 0 && (
    <div className="project-gallery">
      {project?.img.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`${project?.title} ${index + 1}`}
        />
      ))}
      <p>mbassy Greenshore is a premium residential development located within the prestigious Embassy Springs Township in Devanahalli, North Bengaluru, near Kempegowda International Airport. Developed by the renowned Embassy Group, the project offers thoughtfully designed homes set amidst landscaped greenery and a peaceful lakeside environment. Embassy Greenshore combines modern architecture with township living, giving residents the advantage of both privacy and community lifestyle. The project is planned with wide internal roads, open spaces, pedestrian pathways, and recreational zones, ensuring comfortable and healthy living for families.

Residents of Embassy Greenshore enjoy access to a wide range of lifestyle amenities including a clubhouse, swimming pool, gymnasium, indoor and outdoor sports courts, jogging tracks, children’s play areas, and relaxation gardens. Being part of the larger Embassy Springs Township, homeowners also benefit from a self-sustained ecosystem featuring a school, healthcare facilities, retail spaces, parks, and a large central lake. The location in the fast-developing airport corridor makes it ideal for both end-users and investors, as the area is witnessing rapid infrastructure growth with IT parks, aerospace hubs, and improved connectivity to the city.</p>
    </div>
  )} */}

  {project?.img && project.img.length > 0 && (
//   <div className="project-overview">
    
//     {/* LEFT IMAGE */}
//     <div className="overview-image">
//       <img
//         src={project.img[0]}
//         alt={project.title}
//       />
//     </div>

<div className="project-overview">

    {/* LEFT IMAGE SLIDER */}
    <div className="overview-image">
      {project.img.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`${project.title}-${index}`}
          className={`overview-slide ${index === currentIndex ? "active" : ""}`}
        />
      ))}
    </div>

    {/* RIGHT CONTENT */}
   <div className="overview-content">
  <h2>{project.overview.heading}</h2>

  {project.overview.paragraphs.map((text, index) => (
    <p key={index}>{text}</p>
  ))}
</div>

  </div>
)}

<section className="summary-alt">
  <h2 className="summary-title">Project Summary</h2>

  <div className="summary-cards">
    {project.summary.map((item, index) => {
      const Icon = ICONS[item.icon];
      return (
        <div className="summary-card" key={index}>
          <div className="icon">
            <Icon size={20} />
          </div>
          <div>
            <span className="label">{item?.label}</span>
            <span className="value">{item?.value}</span>
          </div>
        </div>
      );
    })}
  </div>
</section>
 
    <br/>

<section className="amenities">
  <h2 className="amenities-title">Amenities</h2>

  {project.amenities.map((section, idx) => (
    <div key={idx} className="amenities-section">
      <h3>{section.category}</h3>

      <div className="amenities-grid">
        {section.items.map((item, i) => {
          const Icon = ICONS[item.icon];
          return (
            <div key={i} className="amenity-card">
              <Icon size={28} />
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  ))}
</section>
     


 
      </section>
    <EnquiryModal
  open={openEnquiry}
  onClose={() => setOpenEnquiry(false)}
  onSuccess={() => setBrochureUnlocked(true)}
  project={project?.Brochure}
/>

      {/* ✅ FOOTER */}
      <Footer />
    </>
  );
};

export default ProjectDetails;
